import { DefaultTheme } from "./DefaultTheme";
export class LightTheme {
}
LightTheme.theme = {
    chatAiTheme: {
        ...DefaultTheme.theme.chatAiTheme,
    },
    appSignUpButtonTheme: {
        ...DefaultTheme.theme.appSignUpButtonTheme,
    },
    patchTheme: {
        inputLeftLineWidth: "5px",
        inputLeftLineHeight: "40px",
        inputLeftLineBorderRadius: "2px",
        inputLeftLineBackground: "rgba(18, 25, 43, 0.10)",
    },
};
